import type { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import GoToSummaryButton, { type GoToSummaryButtonProps } from '@/components/ui/go-to-summary-button';
import { useGuardedFormStepper } from '@/components/ui/guarded-form-stepper';
import { useDetailsNext } from '@/features/institution/hooks/useDetailsNext';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';
import { INSTITUTION_DETAILS_VERSION } from '@/services/api/profile';

const InstitutionGoToReviewButton = <T extends FieldValues>(props: GoToSummaryButtonProps<T>) => {
  const { data: detailsNext, version } = useDetailsNext(INSTITUTION_DETAILS_TYPE.ONBOARDING);
  const { t } = useTranslation();

  if (version !== INSTITUTION_DETAILS_VERSION.V2 || detailsNext?.key !== 'authorisation') return null;

  return (
    <GoToSummaryButton incompleteSectionMessage={t('institutionDetails.review.incompleteSection')} {...props}>
      {t('institutionDetails.review.goToReview')}
    </GoToSummaryButton>
  );
};
InstitutionGoToReviewButton.displayName = 'InstitutionGoToReviewButton';

export const InstitutionGoToReviewStepperButton = <T extends FieldValues>({
  onIncompleteSection,
  onSubmit,
}: Pick<GoToSummaryButtonProps<T>, 'onIncompleteSection' | 'onSubmit'>) => {
  const { nextStep } = useGuardedFormStepper<T>();

  return <InstitutionGoToReviewButton onIncompleteSection={onIncompleteSection ?? (() => nextStep())} onSubmit={onSubmit} />;
};
InstitutionGoToReviewStepperButton.displayName = 'InstitutionGoToReviewStepperButton';

export default InstitutionGoToReviewButton;
